<template>
  <base-card tabled>
    <base-table>
      <thead>
        <tr>
          <th>Location</th>
          <th>Return p.a.</th>
          <th>Loan to value</th>
          <th>Term remaining</th>
          <th>Availability</th>
          <th/>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(investment, key) in investments" :key="key">
          <td>{{ investment.title }}</td>
          <td>{{ investment.funding.interestRate }}%.</td>
          <td>{{ investment.ltv }}%</td>
          <td>{{ $investment.getRemainingTerm(investment) }}</td>
          <td>{{ $formatting.toCurrency($investment.getAvailableAmount(investment)) }}</td>
          <td>
            <div class="btn-group">
              <base-button secondary small :to="{ name: 'co-funding.opportunity', params: { id: investment._id } }">
                Fund Loan
              </base-button>
            </div>
          </td>
        </tr>
      </tbody>
    </base-table>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InvestmentList',

  computed: {
    ...mapState({
      investments: store => store.core.investments.opportunities
    })
  }
}
</script>
